
import { Button } from "@/components/ui/button";
import { ArrowLeft, Plus, FileText, Wrench } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Order } from "@/hooks/useOrdersManagement/types";

interface ProductListHeaderProps {
  order: Order;
  onBack: () => void;
  onAddProduct: () => void;
  onCreditReport: () => void;
}

export const ProductListHeader = ({ 
  order, 
  onBack, 
  onAddProduct, 
  onCreditReport 
}: ProductListHeaderProps) => {
  const navigate = useNavigate();

  return (
    <div className="bg-white rounded-lg shadow-sm border p-3 md:p-4 mb-4 md:mb-6">
      <div className="flex flex-col gap-3 md:gap-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2 md:gap-3 min-w-0 flex-1">
            <Button variant="outline" onClick={onBack} size="sm" className="shrink-0">
              <ArrowLeft className="w-4 h-4" />
              <span className="hidden sm:inline ml-1">Back</span>
            </Button>
            <div className="min-w-0">
              <h1 className="text-lg md:text-xl lg:text-2xl font-bold text-gray-900 truncate">Order Details</h1>
              <p className="text-xs md:text-sm text-gray-600 truncate">{order.supplierName} - #{order.id}</p>
            </div>
          </div>
        </div>
        <div className="flex flex-col sm:flex-row gap-2">
          <Button 
            onClick={() => navigate(`/order-workstation/${order.id}`)} 
            size="sm" 
            variant="outline"
            className="shrink-0 text-blue-600 border-blue-200 hover:bg-blue-50"
          >
            <Wrench className="w-4 h-4" />
            <span className="ml-1 hidden sm:inline">Work Station</span>
            <span className="ml-1 sm:hidden">Station</span>
          </Button>
          <Button 
            onClick={onCreditReport} 
            size="sm" 
            variant="outline"
            className="shrink-0 text-orange-600 border-orange-200 hover:bg-orange-50"
          >
            <FileText className="w-4 h-4" />
            <span className="ml-1 hidden sm:inline">Credit Report</span>
            <span className="ml-1 sm:hidden">Credit</span>
          </Button>
          <Button onClick={onAddProduct} size="sm" className="shrink-0 bg-green-600 hover:bg-green-700">
            <Plus className="w-4 h-4" />
            <span className="ml-1 hidden sm:inline">Add Product</span>
            <span className="ml-1 sm:hidden">Add</span>
          </Button>
        </div>
      </div>
    </div>
  );
};
